$(document).ready(function(){ 
     $("#NewsletterForm--template--17562538410164__newsletter_nm9Kkm").attr("placeholder","Enter Policy or Guideline you are looking for?");
  
});
$(document).ready(function(){ 
     $("#NewsletterForm--template--15933789175988__newsletter_mCkWfT").attr("placeholder","Enter Policy or Guideline you are looking for?");
  
});
   
  

 
$(document).ready(function(){
$(".section-template--17562538410164__rich_text_3YFa9a-padding a").click(function(){ 
  
  $(".section-template--17562538410164__rich_text_3YFa9a-padding .rich-text__text.typeset2.rte").toggleClass("main");
  $(".section-template--17562538410164__rich_text_3YFa9a-padding .button").toggleClass("main");
  
});  
}); 
$('.button').attr('aria-disabled', 'disabled');

$(document).ready(function(){
  var i = 1;
$('.section').each(function(){
    $(this).addClass('myclass'+i);
    i++;
});
    $(".section").addClass("intro");
    
   
}); 
$(document).ready(function(){
  var j = 1;
$('.video-slide').each(function(){
    $(this).addClass('myslide'+j);
    j++;
});
     
  $(".myslide1").addClass("slideactive"); 
});
 
 
setInterval(function () { 
   $('.myclass3333').toggleClass('active');
 
}, 5000);

setInterval(function () { 
   $('.myclass4333').toggleClass('active');
 
}, 10000);
$(function() {
 $('.myclass2').addClass('active2');
});
 

setInterval(function () {  
    if($('.myclass3').hasClass('intro')){
        $('.myclass3').addClass('active');
		$('.myclass3').removeClass('intro'); 
       
    }
else if ($('.myclass3').hasClass('active')){
         $('.myclass4').addClass('active'); 
  $('.myclass3').removeClass('active'); 
    $('.myclass2').removeClass('active2');      
      
    }
  else if ($('.myclass4').hasClass('active')){
         $('.myclass2').addClass('active');  
      $('.myclass4').removeClass('active'); 
      
    }
  else  {
         $('.myclass3').addClass('active'); 
    $('.myclass2').removeClass('active'); 
      
    };
  
}, 6000);


setInterval(function () {  
    if($('.myslide1').hasClass('slideactive')){
        $('.myslide2').addClass('slideactive');
		$('.myslide1').removeClass('slideactive'); 
       
    } 
  else  {
         $('.myslide1').addClass('slideactive'); 
    $('.myslide2').removeClass('slideactive'); 
      
    };
  
}, 8100);


